/* eslint-disable max-len */

import type { ApiLangPack } from '../api/types'

export const fallbackLangPackInitial = {
  WrongNumber: {
    key: 'WrongNumber',
    value: 'Wrong number?',
  },
  SentAppCode: {
    key: 'SentAppCode',
    value: "We've sent the code to the **MM Chat** app on your other device.",
  },
  'Login.JustSentSms': {
    key: 'Login.JustSentSms',
    value: 'We have sent you a code via SMS. Please enter it above.',
  },
  'Login.Header.Password': {
    key: 'Login.Header.Password',
    value: 'Enter Password',
  },
  'Login.EnterPasswordDescription': {
    key: 'Login.EnterPasswordDescription',
    value: 'You have Two-Step Verification enabled, so your account is protected with an additional password.',
  },
  StartText: {
    key: 'StartText',
    value: 'Please confirm your country code and enter your phone number.',
  },
  'Login.PhonePlaceholder': {
    key: 'Login.PhonePlaceholder',
    value: 'Your phone number',
  },
  'Login.Next': {
    key: 'Login.Next',
    value: 'Next',
  },
  'Login.QR.Login': {
    key: 'Login.QR.Login',
    value: 'Log in by QR Code',
  },
  'Login.QR.Title': {
    key: 'Login.QR.Title',
    value: 'Log in to MM Chat by QR Code',
  },
  'Login.QR.Help1': {
    key: 'Login.QR.Help1',
    value: 'Open MM Chat on your phone',
  },
  'Login.QR.Help2': {
    key: 'Login.QR.Help2',
    value: 'Go to **Settings** > **Devices** > **Link Desktop Device**',
  },
  'Login.QR2.Help2': {
    key: 'Login.QR.Help2',
    value: 'Go to **Settings** → **Devices** → **Link Desktop Device**',
  },
  'Login.QR.Help3': {
    key: 'Login.QR.Help3',
    value: 'Point your phone at this screen to confirm login',
  },
  'Login.QR.Cancel': {
    key: 'Login.QR.Cancel',
    value: 'Log in by phone Number',
  },
  'Login.KeepMeLoggedIn': {
    key: 'Login.KeepMeLoggedIn',
    value: 'Keep me signed in',
  },
  'LoginPassword.PasswordPlaceholder': {
    key: 'LoginPassword.PasswordPlaceholder',
    value: 'Password',
  },
  YourName: {
    key: 'YourName',
    value: 'Your Name',
  },
  'Login.Register.Desc': {
    key: 'Login.Register.Desc',
    value: 'Enter your name and add a profile picture.',
  },
  'Login.Register.FirstName.Placeholder': {
    key: 'Login.Register.FirstName.Placeholder',
    value: 'First Name',
  },
  'Login.Register.LastName.Placeholder': {
    key: 'Login.Register.LastName.Placeholder',
    value: 'Last Name',
  },
  'Login.SelectCountry.Title': {
    key: 'Login.SelectCountry.Title',
    value: 'Country',
  },
  lng_country_none: {
    key: 'lng_country_none',
    value: 'Country not found',
  },
  PleaseEnterPassword: {
    key: 'PleaseEnterPassword',
    value: 'Enter your new password',
  },
  PHONE_NUMBER_INVALID: {
    key: 'PHONE_NUMBER_INVALID',
    value: 'Invalid phone number',
  },
  PHONE_CODE_INVALID: {
    key: 'PHONE_CODE_INVALID',
    value: 'Invalid code',
  },
  PASSWORD_HASH_INVALID: {
    key: 'PASSWORD_HASH_INVALID',
    value: 'Incorrect password',
  },
  'Passport.FloodError': {
    key: 'Passport.FloodError',
    value: 'Limit exceeded. Please try again later',
  },
  'Login.New.PhoneBannedError': {
    key: 'Login.New.PhoneBannedError',
    value: 'This phone number is banned',
  },
  lng_cloud_password_bad_email: {
    key: 'lng_cloud_password_bad_email',
    value: 'Invalid Email',
  },
  ErrorEmailUnconfirmed: {
    key: 'ErrorEmailUnconfirmed',
    value: 'Email unconfirmed',
  },
  ErrorEmailHashExpired: {
    key: 'ErrorEmailHashExpired',
    value: 'Email hash expired',
  },
  ErrorNewSettingsInvalid: {
    key: 'ErrorNewSettingsInvalid',
    value: 'The new password settings are invalid',
  },
  InvalidCode: {
    key: 'InvalidCode',
    value: 'Invalid Code',
  },
  ErrorNewSaltInvalid: {
    key: 'ErrorNewSaltInvalid',
    value: 'The new salt is invalid',
  },
  ErrorPasswordChanged: {
    key: 'ErrorPasswordChanged',
    value: 'The password has been changed from another session',
  },
  ErrorPasswordMissing: {
    key: 'ErrorPasswordMissing',
    value: 'A password is required to log in to this account',
  },
  ErrorUnexpectedMessage: {
    key: 'ErrorUnexpectedMessage',
    value: 'Unexpected error: %@',
  },
  ErrorUnexpected: {
    key: 'ErrorUnexpected',
    value: 'Unexpected error',
  },
  FloodWaitTime: {
    key: 'FloodWaitTime',
    value: 'Too many attempts, please try again in %@',
  },
  Seconds: {
    key: 'Seconds',
    oneValue: '%d second',
    otherValue: '%d seconds',
  },
  Minutes: {
    key: 'Minutes',
    oneValue: '%d minute',
    otherValue: '%d minutes',
  },
  Hours: {
    key: 'Hours',
    oneValue: '%d hour',
    otherValue: '%d hours',
  },
  Days: {
    key: 'Days',
    oneValue: '%d day',
    otherValue: '%d days',
  },
  'Button.Loading': {
    key: 'Button.Loading',
    value: 'Please wait...',
  },
  GroupCallDeviceCamera: {
    key: 'GroupCallDeviceCamera',
    value: 'Camera',
  },
  GroupCallDeviceMicrophone: {
    key: 'GroupCallDeviceMicrophone',
    value: 'Microphone',
  },
  GroupCallDeviceSpeaker: {
    key: 'GroupCallDeviceSpeaker',
    value: 'Speaker',
  },
  'GroupCall.Join.Title': {
    key: 'GroupCall.Join.Title',
    value: 'Join Group Call',
  },
  'GuestGroupCall.Join.Description': {
    key: 'GuestGroupCall.Join.Description',
    value: 'Enter your name and choose camera and microphone settings before joining.',
  },
  AccDescrMuteMic: {
    key: 'AccDescrMuteMic',
    value: 'Mute microphone',
  },
  AccDescrUnmuteMic: {
    key: 'AccDescrUnmuteMic',
    value: 'Unmute microphone',
  },
  SelectMicrophone: {
    key: 'SelectMicrophone',
    value: 'Select microphone',
  },
  StopCamera: {
    key: 'StopCamera',
    value: 'Stop camera',
  },
  StartCamera: {
    key: 'StartCamera',
    value: 'Start camera',
  },
  SelectCamera: {
    key: 'SelectCamera',
    value: 'Select camera',
  },
  lng_view_button_call: {
    key: 'lng_view_button_call',
    value: 'Join call',
  },
  Loading: {
    key: 'Loading',
    value: 'Loading...',
  },
  WebErrorTitle: {
    key: 'WebErrorTitle',
    value: 'Oops...',
  },
  'Error.AnError': {
    key: 'Error.AnError',
    value: 'An error occurred. Please try again later.',
  },
  'WebApp.ReloadPage': {
    key: 'WebApp.ReloadPage',
    value: 'Reload Page',
  },
} as ApiLangPack
